import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';
import { AUTOCALLER_URL } from '@shared/helpers/env';

class OperatorSkillsServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  createSkill(id, params = {}) {
    return this.http.post(`/${id}/skills`, params);
  }

  editSkill(id, skillId, params = {}) {
    return this.http.put(`/${id}/skills/${skillId}`, params);
  }

  deleteSkill(id, skillId) {
    return this.http.delete(`/${id}/skills/${skillId}`);
  }
}

export const OperatorSkillsService = new OperatorSkillsServiceClass({
  api_version: 1,
  base_url: AUTOCALLER_URL,
  resource: 'operators'
});
